import { render, staticRenderFns } from "./PanelMujer.vue?vue&type=template&id=5d06acb5&scoped=true"
import script from "./PanelMujer.vue?vue&type=script&lang=js"
export * from "./PanelMujer.vue?vue&type=script&lang=js"
import style0 from "./PanelMujer.vue?vue&type=style&index=0&id=5d06acb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d06acb5",
  null
  
)

export default component.exports